module.exports = __webpack_public_path__ + "static/checkbox-1-c6293c27da538de72ac04e684e2a67bf.png";